import { Label, styled } from '@a0/quantum-product';
import * as React from 'react';
var StyledLabel = styled(Label)({
    verticalAlign: 'middle',
});
export var BetaBadge = function () { return (React.createElement(StyledLabel, { ml: 1, color: "primary", variant: "filled" }, "Beta")); };
